/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Embed_Captions_Submitted_Text_MultipleInputs */

const en_embed_captions_submitted_text_multiple = /** @type {(inputs: Embed_Captions_Submitted_Text_MultipleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} embed jobs have been submitted. You will receive a separate email for each video when it is complete.`)
};

const fr_embed_captions_submitted_text_multiple = /** @type {(inputs: Embed_Captions_Submitted_Text_MultipleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tâches d'intégration ont été soumises. Vous recevrez un e-mail distinct pour chaque vidéo une fois terminée.`)
};

const de_embed_captions_submitted_text_multiple = /** @type {(inputs: Embed_Captions_Submitted_Text_MultipleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Einbettungsjobs wurden eingereicht. Sie erhalten für jedes Video eine separate E-Mail, sobald es fertig ist.`)
};

const it_embed_captions_submitted_text_multiple = /** @type {(inputs: Embed_Captions_Submitted_Text_MultipleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sono stati inviati ${i?.count} lavori di incorporamento. Riceverai un'e-mail separata per ogni video al termine.`)
};

const ru_embed_captions_submitted_text_multiple = /** @type {(inputs: Embed_Captions_Submitted_Text_MultipleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отправлено заданий на встраивание: ${i?.count}. Для каждого видео по завершении вы получите отдельное письмо.`)
};

const es_embed_captions_submitted_text_multiple = /** @type {(inputs: Embed_Captions_Submitted_Text_MultipleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se han enviado ${i?.count} trabajos de incrustación. Recibirá un correo electrónico independiente por cada video cuando esté listo.`)
};

const zh_cn2_embed_captions_submitted_text_multiple = /** @type {(inputs: Embed_Captions_Submitted_Text_MultipleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已提交 ${i?.count} 个嵌入任务。每个视频完成后，您将收到单独的电子邮件。`)
};

const ja_embed_captions_submitted_text_multiple = /** @type {(inputs: Embed_Captions_Submitted_Text_MultipleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件の埋め込みジョブを送信しました。各動画の完了時に個別のメールが届きます。`)
};

const hi_embed_captions_submitted_text_multiple = /** @type {(inputs: Embed_Captions_Submitted_Text_MultipleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} एम्बेड जॉब सबमिट कर दिए गए हैं। प्रत्येक वीडियो पूरा होने पर आपको अलग ईमेल मिलेगा।`)
};

const pt_pt2_embed_captions_submitted_text_multiple = /** @type {(inputs: Embed_Captions_Submitted_Text_MultipleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Foram enviados ${i?.count} trabalhos de incorporação. Receberá um e-mail separado para cada vídeo quando estiver concluído.`)
};

/**
* | output |
* | --- |
* | "{count} embed jobs have been submitted. You will receive a separate email for each video when it is complete." |
*
* @param {Embed_Captions_Submitted_Text_MultipleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_submitted_text_multiple = /** @type {((inputs: Embed_Captions_Submitted_Text_MultipleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Submitted_Text_MultipleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_submitted_text_multiple(inputs)
	if (locale === "de") return de_embed_captions_submitted_text_multiple(inputs)
	if (locale === "it") return it_embed_captions_submitted_text_multiple(inputs)
	if (locale === "ru") return ru_embed_captions_submitted_text_multiple(inputs)
	if (locale === "es") return es_embed_captions_submitted_text_multiple(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_submitted_text_multiple(inputs)
	if (locale === "ja") return ja_embed_captions_submitted_text_multiple(inputs)
	if (locale === "hi") return hi_embed_captions_submitted_text_multiple(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_submitted_text_multiple(inputs)
	return en_embed_captions_submitted_text_multiple(inputs)
});